import d from "classnames";
import o, { forwardRef as j, useMemo as f, useCallback as k } from "react";
import { D as v, s as g } from "../default-image-wuU85H68.mjs";
const x = (e) => e && Array.isArray(e) && e.length > 0, D = ({ template: e }) => e && typeof e == "string", M = (e) => e && e.length && e.every(D), T = j(
  ({
    alt: e,
    src: r = "",
    isAltReal: u = !1,
    border: p,
    dataTestId: $,
    sources: i = [],
    lazy: y = !1,
    fetchPriority: h,
    className: S,
    ...c
  }, I) => {
    const m = f(() => r.includes("?") ? `${r}&` : `${r}?`, [r]), a = k(
      (t) => t != null && t.length ? `${m}${t.join("&")}` : r,
      [r, m]
    ), _ = f(() => {
      const t = ["fmt=auto"];
      return x(i) ? i.map(({ media: n, srcsetList: s }) => {
        if (!M(s))
          return a(t);
        const E = [...t];
        return {
          media: n,
          srcSet: s.map(({ template: b, scale: l }) => {
            const N = [`$${b}$`, ...E], P = l ? ` ${l}` : "";
            return `${a(N)}${P}`;
          }).join(", ")
        };
      }) : [{ srcSet: a(t) }];
    }, [a, i]);
    return r ? /* @__PURE__ */ o.createElement(
      "picture",
      {
        ...c,
        className: d(g.productImage, "fuse-product-image", S),
        style: { "--product-image-border": p }
      },
      _.map((t, n) => /* @__PURE__ */ o.createElement("source", { key: t.media || n, ...t })),
      /* @__PURE__ */ o.createElement(
        "img",
        {
          src: `${m}fmt=auto`,
          alt: e,
          ref: I,
          loading: y ? "lazy" : "eager",
          fetchPriority: h || "auto",
          "data-testid": $ || "fuse-product-image",
          "aria-hidden": u ? void 0 : "true",
          className: d(g.productImage__img, "fuse-product-image__img")
        }
      )
    ) : /* @__PURE__ */ o.createElement(v, { alt: e, isAltReal: u, ...c });
  }
);
T.displayName = "ProductImage";
export {
  T as ProductImage
};
